var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOxygenGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.49,
    height: 23.795,
    viewBox: "0 0 20.49 23.795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15123",
    "data-name": "Group 15123",
    transform: "translate(-263.796 -345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41159",
    "data-name": "Path 41159",
    d: "M282.109,360.978a9.157,9.157,0,1,1-9.187-9.244A9.165,9.165,0,0,1,282.109,360.978Zm-17.532-.681c-.019.413.144.639.432.674a.508.508,0,0,0,.575-.47c.011-.054.012-.109.018-.165a7.62,7.62,0,0,1,1.674-4.079,8.057,8.057,0,0,1,2.17-1.831,5.8,5.8,0,0,1,1.521-.634.5.5,0,0,0,.375-.64.516.516,0,0,0-.623-.345,1.964,1.964,0,0,0-.2.062,8.879,8.879,0,0,0-3.409,2.057,8.694,8.694,0,0,0-1.145,1.414A8.41,8.41,0,0,0,264.577,360.3Zm3.836,1.467a3.184,3.184,0,0,0,.364,1.693,2.439,2.439,0,0,0,2.253,1.306,2.377,2.377,0,0,0,2.269-1.271,3.262,3.262,0,0,0-.038-3.261,2.621,2.621,0,0,0-4.57.252A3.039,3.039,0,0,0,268.413,361.765Zm6.055.385a.325.325,0,0,0,.083.049c.292.057.586.164.693-.288.043-.181.3-.24.5-.194a.432.432,0,0,1,.347.412.73.73,0,0,1-.2.57c-.148.165-.306.32-.465.474a6.148,6.148,0,0,0-.712.754,1.4,1.4,0,0,0-.317.842c.742,0,1.446,0,2.15,0,.146,0,.226-.033.239-.2.029-.4,0-.438-.419-.441l-.953,0a5.966,5.966,0,0,1,.75-.773,2.03,2.03,0,0,0,.542-.774,1.006,1.006,0,0,0-.169-1.087,1.236,1.236,0,0,0-1.344-.281A.972.972,0,0,0,274.468,362.149Z",
    transform: "translate(0 -1.393)",
    fill: "#72d54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41160",
    "data-name": "Path 41160",
    d: "M285.534,352.928a2.72,2.72,0,1,1,2.685-2.706A2.712,2.712,0,0,1,285.534,352.928Zm-2.134-2.877a2.612,2.612,0,0,0,.418,1.584.4.4,0,0,0,.638.083c.158-.149.165-.321.025-.584a1.673,1.673,0,0,1,.3-2.1,1.008,1.008,0,0,0,.072-.071.4.4,0,0,0-.011-.552.406.406,0,0,0-.525-.054,1.17,1.17,0,0,0-.182.149A2.273,2.273,0,0,0,283.4,350.051Z",
    transform: "translate(-3.933 -0.515)",
    fill: "#72d54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41161",
    "data-name": "Path 41161",
    d: "M281.606,346.384a1.374,1.374,0,1,1-2.748.016,1.379,1.379,0,0,1,1.37-1.4A1.365,1.365,0,0,1,281.606,346.384Zm-2.4.058a1.1,1.1,0,0,0,.573.942.248.248,0,0,0,.283.03.267.267,0,0,0,.106-.267.471.471,0,0,0-.241-.348.465.465,0,0,1-.074-.754c.055-.061.12-.115.168-.181a.367.367,0,0,0,.047-.434c-.085-.089-.271-.064-.424.065A1.183,1.183,0,0,0,279.211,346.442Z",
    transform: "translate(-3.115 0)",
    fill: "#72d54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41162",
    "data-name": "Path 41162",
    d: "M270.549,363.936a3.865,3.865,0,0,1,.129-.945,1.792,1.792,0,0,1,1.609-1.3,1.761,1.761,0,0,1,1.756.945,2.9,2.9,0,0,1,.066,2.492,1.765,1.765,0,0,1-2.012,1.038,1.845,1.845,0,0,1-1.505-1.614C270.562,364.351,270.563,364.143,270.549,363.936Z",
    transform: "translate(-1.397 -3.451)",
    fill: "#72d54a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxygenGreen);
export default __webpack_public_path__ + "static/media/oxygen-green.a255e35e58a608b5e91cef428834662c.svg";
export { ForwardRef as ReactComponent };